import { Box, Container, Typography } from "@material-ui/core";
import { Row } from "components/Row";
import './index.scss';
import UploadCloud from "assets/icons/UploadCloudIcon";
import React, { useRef, ChangeEvent, DragEvent } from "react";
import UploadFileCheck from "assets/icons/UploadFileCheckIcon";
import UploadDeleteIcon from "assets/icons/UploadDeleteIcon";
import SnackbarUtils from "utils/SnackbarUtils";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { addSingleFile, clearUploadedFile } from "store/modules/AllContratos/AllContratosActions";

interface ModalFilesProps {
  id: number | null;
  file: File | null;
  setFile: (file: File | null) => void;
  clearFile: () => void;
}

const CustomUploadSingle = ({ id, file, setFile, clearFile }: ModalFilesProps) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const languageValues = useSelector((states: RootState) => states.languages.languageValues);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement> | DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    let files: FileList | null = null;

    if ('dataTransfer' in event) {
      files = event.dataTransfer.files;
    } else {
      files = event.target.files;
    }

    if (files && files.length > 0) {
      const validExtensions = ['pdf', 'doc'];
      const newFiles = Array.from(files).filter(currentFile => validExtensions.includes(currentFile.name.split('.').pop()?.toLowerCase() || ''));

      if (newFiles.length > 0) {
        const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

        if (newFiles[0].size > MAX_FILE_SIZE) {
          SnackbarUtils.enqueueSnackbar({
            message: languageValues.errorLimited10MBFiles,
            options: { variant: 'error' },
          });
          return;
        }

        dispatch(addSingleFile(newFiles[0]));
        setFile(newFiles[0]);
      } else {
        SnackbarUtils.enqueueSnackbar({
          message: languageValues.errorValidationFiles,
          options: { variant: 'error' },
        });
      }
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleDragOver = (event: DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>): void => {
    event.preventDefault();
    handleFileChange(event);
  };

  const handleClick = (): void => {
    fileInputRef.current?.click();
  };

  const handleDelete = (event: React.MouseEvent): void => {
    dispatch(clearUploadedFile());
    event.stopPropagation();
    clearFile()
  };

  const truncateFileName = (name: string, maxLength = 35): string => {
    return name.length > maxLength ? name.slice(0, maxLength) + '...' : name;
  };

  return (
    <Container maxWidth='lg' style={{ padding: 0 }}>
      <Row>
        <Box
          className="customUpload__card-box"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={handleClick}
        >
          <input
            type="file"
            accept=".pdf, .doc"
            onChange={handleFileChange}
            className={`customUpload__file-input-${id}`}
            style={{ display: 'none' }}
            ref={fileInputRef}
          />
          <Box className="customUpload__card-box-icon">
            <span>
              {file
                ? <UploadFileCheck color={'#3FA110'} />
                : <UploadCloud color={'#828A82'} />}
            </span>
          </Box>
          <Box className="customUpload__content-text">
            {file ? (
              <Typography className="customUpload__content-name-files">
                {truncateFileName(file.name)}
                <span onClick={handleDelete}>
                  <UploadDeleteIcon
                    className="customUpload__icon-delete"
                    color={'#A00100'}
                  />
                </span>
              </Typography>
            ) : (
              <Typography variant="body1" className="customUpload__content-description">
                Arraste e solte o arquivo nesta área ou <span className="customUpload__highlighted"> procure no dispositivo.</span>
              </Typography>
            )}
          </Box>
        </Box>
      </Row>
    </Container>
  );
};

export default CustomUploadSingle;